/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { EditorID } from 'Cloud/Application/Editor/types';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';
import config from 'Cloud/config';
import { pathEq } from 'ramda';
import { connect } from 'react-redux';
import { removeItems } from 'reactApp/appHelpers/appHelpers';
import {
    HIDE_ADS,
    IS_BLOCKED,
    IS_DISK_ONLY,
    IS_FAMILY_USER,
    IS_ONPREMISE,
    IS_TABLET_BROWSER,
    MYOFFICE_ATTACHES_VIEWER,
    VIEWERS_CONFIG,
} from 'reactApp/appHelpers/configHelpers';
import { isWopiEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { blockOverqueotaViewer } from 'reactApp/appHelpers/featuresHelpers/features/blockOverquotaViewer';
import { clearRenamedFileIdInsideViewer, getRenamedFileIdInsideViewer } from 'reactApp/appHelpers/updateRenamedFileInsideViewer';
import { AttachesSelectors } from 'reactApp/modules/attaches/attaches.selectors';
import { type AttachesItem, EAttachTypes } from 'reactApp/modules/attaches/attaches.types';
import { isDialogVisible } from 'reactApp/modules/dialog/dialog.selectors';
import { EditorRestrictionsActions } from 'reactApp/modules/editorRestrictions/editorRestrictions.module';
import { EditorRestrictionsSelectors } from 'reactApp/modules/editorRestrictions/editorRestrictions.selectors';
import { selectFace } from 'reactApp/modules/faces/faces.module';
import { getFacesOnFile } from 'reactApp/modules/faces/faces.selectors';
import type { IFaceWithCoordinates } from 'reactApp/modules/faces/faces.types';
import { FavoritesSelectors } from 'reactApp/modules/favorites/favorites.selectors';
import {
    getAstraMetaFeature,
    getFeatureAttachesEnabled,
    getFeatureMyOfficeViewerPromo,
    getFeatureNewAdFormat,
    getFeaturesAttachesTrialPromo,
    getFeatureViewerLocalDocAttaches,
} from 'reactApp/modules/features/features.selectors';
import { getWeblinkFromPublicId, isFileForPlayer, isImage, isPreviewable, isVideo } from 'reactApp/modules/file/utils';
import { isThisOrParentMounted } from 'reactApp/modules/home/home.selectors';
import type { Item } from 'reactApp/modules/home/home.types';
import { addToFavorites, removeFromFavorites } from 'reactApp/modules/modifying/modifying.actions';
import { getPublicLimits, isOwnPublic } from 'reactApp/modules/public/public.selectors';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getCurrentRouteId, getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { newSendSearchRadarAnalytics } from 'reactApp/modules/search/search.analytics';
import { getSearchAnalyticsParams } from 'reactApp/modules/search/search.selectors';
import { setBottomMarginAction, showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import type { StockItem } from 'reactApp/modules/stock/stock.type';
import { getStorage, isIntegrationStorage } from 'reactApp/modules/storage/storage.helpers';
import { getStorageItemById, hasParentMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { type CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { markStoryAsViewed as markStoryAsViewedAction } from 'reactApp/modules/stories/stories.module';
import { getAdjacentStoryIds, getStoryForViewer } from 'reactApp/modules/stories/stories.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { selectIsViewerItemEditable } from 'reactApp/modules/viewer/selectIsViewerItemEditable';
import {
    closeViewer,
    downloadArchiveItemRequest,
    openPdfEditor,
    publishItem,
    selectItemIndexInArray as selectItemIndexInArrayAction,
    setOvidiusZoom,
} from 'reactApp/modules/viewer/viewer.module';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { isVisiblePromo } from 'reactApp/ui/MyOfficePromo/ViewerSnackbar/ViewerSnackbarPromoContainer';
import { NUMBER_TO_PRELOAD } from 'reactApp/ui/ReactViewer/ReactViewer.constants';
import { getFitContentOption, getItemImageUrl, getPosterUrl, setFitContentOption } from 'reactApp/ui/ReactViewer/ReactViewer.helpers';
import { ReactViewerComponent } from 'reactApp/ui/ReactViewer/ReactViewerComponent';
import { TRIAL_ATTACHES_BANNER_ID } from 'reactApp/ui/TrialPromoBanner/TrialPromoBanner';
import { noopVoid } from 'reactApp/utils/helpers';
import { closeViewerUrl } from 'reactApp/utils/urlHelper';
import { getAvailableEditorsFor } from 'server/helpers/editors/getEditors';
import type { ServerEditor } from 'server/helpers/editors/types';

/**
 * TypeGuard: проверка на то, что файл аттач любого вида
 */
const isAttachOrStockFile = (file: CloudItem): file is AttachesItem | StockItem => {
    return (
        ([EStorageType.attaches, EStorageType.viewerAttaches].includes(file?.storage) &&
            [EAttachTypes.attach, EAttachTypes.cloud, EAttachTypes.temporary, EAttachTypes.cloudStock].includes(
                (file as AttachesItem)?.attachType
            )) ||
        file?.storage === EStorageType.stock
    );
};

const r7WopiFeature = getFeature('r7wopi');

const isR7WopiFeatureAvailable =
    typeof r7WopiFeature === 'object' && (typeof r7WopiFeature?.edit?.length || typeof r7WopiFeature?.view?.length);

const replaceViewer = (viewer: ServerEditor) => VIEWERS_CONFIG.filter((v) => v.id !== EditorID.R7_WOPI).concat(viewer);

// eslint-disable-next-line max-lines-per-function
const mapStateToProps = (state, props) => {
    const promoTrialFeatures = getFeaturesAttachesTrialPromo(state);
    const file = ViewerSelectors.getViewerItem(state);
    const isEditingDisabled = EditorRestrictionsSelectors.isEditingRestricted(state);
    const indexInArray = ViewerSelectors.getViewerItemIndexInArray(state);
    const isActionOpen = ViewerSelectors.isViewerActionOpen(state);
    const ids = ViewerSelectors.getViewerItemIds(state);
    const itemCount = ViewerSelectors.getViewerItemCount(state);
    const hasMoreToLoad = ViewerSelectors.hasMoreToLoad(state);
    const gaSuffix = ViewerSelectors.getViewerGa(state);
    const activeArchiveItem = ViewerSelectors.getArchiveActiveItem(state);
    const ovidiusZoom = ViewerSelectors.getOvidiusZoom(state, file?.id);
    const {
        showEditButton,
        isAttachesCloud,
        isDoc,
        itemStorage,
        isAttachesCloudStock,
        isAttaches,
        isPublic,
        isEditable,
        editingNoneEditableFormats,
        sharedFolderFile,
        sharedFolderFileBtnFeature,
        showPdfEditButton,
    } = selectIsViewerItemEditable(state);
    const isAuthorized = !UserSelectors.isAnonymous(state);
    const isAttachesEnabled = !!getFeatureAttachesEnabled(state) && !IS_DISK_ONLY;
    let preloadUrls: { url: string; id: string }[] = [];

    const email = UserSelectors.getEmail(state);
    const searchParams = getSearchAnalyticsParams(state);
    const isOwner = isOwnPublic(state);
    const attachesSearchState = AttachesSelectors.getSearchState(state);
    const attachesQuery = attachesSearchState?.query;
    const attachesSearchedItem = file && !!attachesSearchState && AttachesSelectors.getAttachById(state, file.id);
    const attachesSearchedItemPos = attachesSearchedItem ? attachesSearchedItem?.pos : undefined;
    const isDialogShown = isDialogVisible(state);
    const isMountedFolder = isThisOrParentMounted(state, file?.parent);
    const hideAdsUsersNonCorp =
        (UserSelectors.isPaidUser(state) || UserSelectors.isBizUser(state) || IS_FAMILY_USER) && !UserSelectors.isCorpUser(state);
    const hideAdsbyMailFlag = UserSelectors.isCorpUser(state) && UserSelectors.isHideAdInMail(state);
    const hideAdsOnAttaches = hideAdsbyMailFlag || hideAdsUsersNonCorp;
    const showBottomAds = (itemStorage === EStorageType.public || itemStorage === EStorageType.stock) && !HIDE_ADS;
    const isNewAdFormat = getFeatureNewAdFormat(state);
    const disableClose = props.disableClose || IS_BLOCKED;
    const isLocalDocAttaches = (isAttachesCloud || isAttachesCloudStock) && isDoc && getFeatureViewerLocalDocAttaches(state);
    const routeId = getCurrentRouteId(state);
    const weblink = getWeblinkFromPublicId(routeId);
    const downloadLimits = getPublicLimits(state, weblink || '');

    /** TODO: CLOUDWEB-16228 сохранить возможность использовать просмотрщики
     *  по умолчанию на аттачах
     */
    const isAttachOrStock = file && isAttachOrStockFile(file);
    const isR7WopiEditorActive = isR7WopiFeatureAvailable && VIEWERS_CONFIG.find((v) => v.id !== EditorID.R7_WOPI);
    const viewers = isAttachOrStock && isR7WopiEditorActive ? replaceViewer(MYOFFICE_ATTACHES_VIEWER) : VIEWERS_CONFIG;

    const featureMyOfficePromoData = getFeatureMyOfficeViewerPromo(state);
    const viewerApi =
        file &&
        getAvailableEditorsFor({
            item: file,
            editors: viewers,
            isEdit: false,
            storage: itemStorage,
            isWopiEnabled,
        })[0];
    const isMyOfficePromo = isVisiblePromo(viewerApi, featureMyOfficePromoData);
    const isTablet = IS_TABLET_BROWSER || browser.isIpadOs();

    /**
     * TODO Убрать костыль-проверку на editingNoneEditableFormats, когда будем рефакторить овидиус.
     * Сейчас мы не можем добавить расширение, которое не является документом, например, .txt
     * На данном этапе добавлена эта проверка, чтобы отображать кнопку редактирования для недокументов для дальнейшей конвертации.
     */
    const isPublicCopyEditable = isPublic && !isTablet && ((isEditable && isDoc) || editingNoneEditableFormats);
    const trialWasShown = UserStorageSelectors.get(state, TRIAL_ATTACHES_BANNER_ID);
    const showTrialPromo =
        !trialWasShown && Boolean(file) && !isMyOfficePromo && isAttaches && promoTrialFeatures && !isFileForPlayer(file);
    const isNewbie = UserSelectors.isNewbie(state);

    let faces: IFaceWithCoordinates[] = [];
    if (itemStorage === EStorageType.public) {
        faces = getFacesOnFile(state, file?.id?.replace(getWeblinkFromPublicId(file?.id) ?? '', ''));
    }

    let isPreviewableItem = isPreviewable(file, itemStorage, viewers);

    if (isAttaches && pathEq(['subKind'], 'archive', file) && !isAttachesCloudStock && !isAttachesCloud) {
        const attachType = file && 'type' in file && file.type;
        // В аттачах все просматриваем, идем в почтовое апи
        // На клауд стоки только зип, и  нужный isPreviewableItem уже выставлен.
        isPreviewableItem = attachType !== EAttachTypes.temporary;
    }

    if (isPreviewableItem && file?.kind === 'document' && isAttaches && !isAttachesCloudStock && !isAttachesCloud) {
        isPreviewableItem = config.get('DOCUMENTS_VIEW_O2_VIEWER')?.length > 0;
    }

    // Файл не надо увеличивать/уменьшать, если мы его не показываем
    const disableZoom = !isPreviewableItem || itemStorage === EStorageType.story;

    const item = (activeArchiveItem ?? file) as Item;
    const hasParentMountedOrShared = item && hasParentMountedOrSharedFolder(state, [item]);

    // TODO: Move preloadUrls update to store or saga?
    // in viewer start and selectIndex?
    if (props.enablePreload && indexInArray !== null && itemStorage && ids) {
        for (let i = indexInArray; i < indexInArray + NUMBER_TO_PRELOAD && i < ids.length; i++) {
            const item = getStorageItemById(state, itemStorage, ids[i]);

            preloadUrls.push({
                url: isVideo(item) ? getPosterUrl(item) : isImage(item) && isPreviewable(item, itemStorage) ? getItemImageUrl(item) : '',
                id: item?.id || '',
            });
        }
    }

    let backItemIndexInArray: number | null = null;
    let forwardItemIndexInArray: number | null = null;
    if (indexInArray !== null && indexInArray !== undefined) {
        backItemIndexInArray = !!ids && indexInArray > 0 ? indexInArray - 1 : null;
        forwardItemIndexInArray = !!ids && indexInArray >= 0 && indexInArray + 1 < ids.length ? indexInArray + 1 : null;

        if (itemStorage === EStorageType.story) {
            const { prevStoryId, nextStoryId } = getAdjacentStoryIds(state);
            backItemIndexInArray = backItemIndexInArray ?? (prevStoryId ? -1 : null);
            forwardItemIndexInArray = forwardItemIndexInArray ?? (nextStoryId ? ids?.length ?? null : null);
        }

        // Для интеграции выключаем возможость листать слайды, пока не будет поддержки всех файлов
        if (isIntegrationStorage(itemStorage)) {
            backItemIndexInArray = null;
            forwardItemIndexInArray = null;
        }
    }

    let storyType, bottomTitle, bottomSubTitle, topSubTitle, topTitle, storyId, isStoryViewed;
    if (itemStorage === EStorageType.story) {
        const data = getStoryForViewer(state, file?.id);
        storyType = data?.type;
        bottomTitle = data?.bottomTitle;
        bottomSubTitle = data?.bottomSubTitle;
        topTitle = data?.topTitle;
        topSubTitle = data?.topSubTitle;
        storyId = data?.id;
        isStoryViewed = data?.viewed;
    }

    const isSearchRadar = itemStorage === EStorageType.search || (!!attachesSearchedItem && isAttaches && !!attachesQuery);

    const astraMetaFeature = getAstraMetaFeature(state);

    // tempexp_17125-start
    const isOverQuota = UserQuotaSelectors.isOverquota(state);
    const { overquota: isOverQuotaServerSide } = config.get('user.cloud.space') || {};
    const blockViewer =
        Boolean(blockOverqueotaViewer) &&
        (isOverQuotaServerSide || isOverQuota) &&
        !isAttaches &&
        itemStorage !== EStorageType.public &&
        itemStorage !== EStorageType.stock &&
        !isIntegrationStorage(itemStorage) &&
        itemStorage !== EStorageType.embedded &&
        !UserSelectors.isCorpUser(state) &&
        !UserSelectors.isBizUser(state) &&
        !UserSelectors.isSocialUser(state) &&
        !IS_ONPREMISE;

    if (blockViewer) {
        preloadUrls = [];
        backItemIndexInArray = null;
        forwardItemIndexInArray = null;
    }
    // tempexp_17125-end

    return {
        file,
        isEditingDisabled,
        viewers,
        activeArchiveItem,
        ids,
        indexInArray,
        itemStorage,
        backItemIndexInArray,
        forwardItemIndexInArray,
        preloadUrls,
        itemCount,
        hasMoreToLoad,
        gaSuffix: gaSuffix ? `_${gaSuffix}` : '',
        isActionOpen,
        isPreviewableItem,
        isAuthorized,
        isPublicCopyEditable,
        isAttaches,
        isNewbie,
        getFitContentState: () => getFitContentOption(email),
        setFitContentState: (isFitContent) => setFitContentOption(email, isFitContent),
        sendSearchRadar: ({ dwhData, items }) => {
            if (isAttaches) {
                dwhData.attaches_query = attachesQuery;
            }

            newSendSearchRadarAnalytics({
                ...dwhData,
                searchParams,
                items,
            });
        },
        isAttachesEnabled,
        isDialogShown,
        isMountedFolder,
        hideAdsOnAttaches,
        isLocalDocAttaches,
        showBottomAds,
        showEditButton,
        sharedFolderFile,
        sharedFolderFileBtnFeature,
        isEditable,
        editingNoneEditableFormats,
        storyId,
        storyType,
        bottomTitle,
        bottomSubTitle,
        topSubTitle,
        topTitle,
        disableZoom,
        isStoryViewed,
        faces,
        isNewAdFormat,
        isSearchRadar,
        showPdfEditButton,
        attachesSearchedItemPos,
        disableClose,
        isOwner,
        showTrialPromo,
        hasParentMountedOrShared,
        ovidiusZoom,
        astraMetaFeature,
        // tempexp_17125-next-line
        blockViewer,
        downloadLimits,
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    showSnackbar: (data) => dispatch(showSnackbarAction(data)),
    publishItemAction: (data) => dispatch(publishItem(data)),
    markStoryAsViewed: ({ storyId, lastViewedId }) =>
        dispatch(
            markStoryAsViewedAction({
                storyId,
                lastViewedId,
            })
        ),
    selectItemIndexInArray: ({ itemIndex }) => dispatch(selectItemIndexInArrayAction({ itemIndex })),
    toggleFavorite: (item): void => {
        dispatch((_, getState) => {
            const state = getState();
            const storage = getCurrentStorage(state);

            const { isFavorites } = getStorage(storage);

            const favoritesStatistics = FavoritesSelectors.getFavoritesStatistics(state);

            /*
                Если в избранном всего один файл,
                то при удалении его из избранного через viewer нужно подчистить урл
            */
            if (isFavorites && item.isInFavorites && favoritesStatistics.all === 1) {
                const closeUrl = closeViewerUrl(location);
                // TODO: routing
                dispatch(historyPush({ id: closeUrl }));
            }

            if (item.isInFavorites) {
                dispatch(removeFromFavorites({ items: [item] }));
            } else {
                dispatch(
                    addToFavorites({
                        items: [item],
                        from: 'viewer',
                    })
                );
            }
        });
    },
    deleteFile: (item: CloudItem, itemStorage?: EStorageType, onSuccess = noopVoid) =>
        removeItems({
            items: [item],
            onSuccess,
        }),
    onClose: () => {
        if (typeof props.onClose === 'function') {
            props.onClose();
        }
        dispatch(closeViewer());
    },
    downloadArchiveItemAction: (data) => dispatch(downloadArchiveItemRequest(data)),
    selectFace: (id) => {
        dispatch(selectFace({ id }));
    },
    getRenamedFileIdInsideViewer: () => dispatch(getRenamedFileIdInsideViewer()),
    clearRenamedFileIdInsideViewer: () => dispatch(clearRenamedFileIdInsideViewer()),
    openPdfEditor: (file: any) => {
        if (!file?.home) {
            return;
        }
        dispatch(openPdfEditor({ id: file.home, storage: EStorageType.home }));
    },
    setBottomMargin: (value: number) => dispatch(setBottomMarginAction(value)),
    setOvidiusZoom: ({ id, value }: { id: string; value: number }) => dispatch(setOvidiusZoom({ id, value })),
    checkEditingDisabled: ({ isR7 }) => {
        dispatch(EditorRestrictionsActions.checkEditingDisabled({ isR7 }));
    },
});

export const ReactViewerConnected = connect(mapStateToProps, mapDispatchToProps)(ReactViewerComponent);

export default ReactViewerConnected;
